import axios from "axios";
import { useAuthStore } from "@/stores/auth-store";
import keycloak from "@/lib/keycloak"; // updateToken-ыг энд ашиглаж болно

const api = axios.create({
  baseURL: "/api",
  withCredentials: true,
});

api.interceptors.request.use(
  async (config) => {
    // Хадгалагдсан токен
    let token = useAuthStore.getState().token;

    if (!token) {
      // Try refreshing from Keycloak if token missing
      console.log("refreshing");
      keycloak
        .updateToken(60)
        .then((refreshed) => {
          if (refreshed) {
            console.log("🔄 Token refreshed", keycloak.token);
          } else {
            console.log("✅ Token still valid", keycloak.token);
          }

          if (keycloak.token) {
            useAuthStore
              .getState()
              .setToken(keycloak.token, keycloak.refreshToken || "");
          }
        })
        .catch((err) => {
          console.warn("[Axios] Failed to refresh token ❌", err);
          useAuthStore.getState().clearToken?.();
          keycloak.logout();
        });
      // try {
      //   const refreshed = await keycloak.updateToken(60);

      //   console.log(refreshed);
      //   if (refreshed && keycloak.token) {
      //     useAuthStore.getState().setToken(keycloak.token, keycloak.refreshToken || "");
      //   }
      // } catch (err) {
      //   console.warn("[Axios] Failed to refresh token ❌", err);
      //   // useAuthStore.getState().clearToken?.(); // if defined
      //   // keycloak.logout();
      // }
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Response interceptor → 401 үед logout
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("[Axios] 401 Unauthorized → Logging out");
      useAuthStore.getState().clearToken();
      keycloak.logout();
    }
    return Promise.reject(error);
  }
);

export default api;
